module.exports = __webpack_public_path__ + "196393a2daa9a139e0b7e74844771a8c.pdf";